import { TextBase } from '@components/v2/text-base'
import cl from 'classnames'

import styles from './styles.module.scss'

interface ColDataProps {
  heading: string
  content: string[]
}

interface Props {
  title?: string
  firstColData?: ColDataProps
  secondColData?: ColDataProps
  firstColHeadingBgColor?: string
  secondColHeadingBgColor?: string
}

export const MarketComparison = ({
  title,
  firstColData,
  secondColData,
  firstColHeadingBgColor = 'bg-v2-bleu-de-france',
  secondColHeadingBgColor = 'bg-orange'
}: Props) => {
  return (
    <div className={styles.container}>
      {title && <TextBase className={styles.title}>{title}</TextBase>}

      <div className={styles.wrapperContent}>
        <div className={styles.column}>
          <div
            className={cl(
              styles.heading,
              firstColHeadingBgColor && firstColHeadingBgColor
            )}
          >
            <TextBase>{firstColData.heading}</TextBase>
          </div>
          <div className={styles.content}>
            {firstColData?.content?.map(item => (
              <TextBase key={item}>{item}</TextBase>
            ))}
          </div>
        </div>

        <div className={styles.divisor}></div>

        <div className={styles.column}>
          <div
            className={cl(
              styles.heading,
              secondColHeadingBgColor && secondColHeadingBgColor
            )}
          >
            <TextBase>{secondColData.heading}</TextBase>
          </div>
          <div className={styles.content}>
            {secondColData?.content?.map(item => (
              <TextBase key={item}>{item}</TextBase>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
